import { primaryExtractionSkippedReason } from '../lib/primaryExtractionSkipped';

export function PrimaryExtractionSkippedNotice({ hash, category }: { hash?: string; category?: string }) {
  const action = 'Set the category to extract.';
  return (
    <p className="mt-1.5 text-sm text-gray-500 dark:text-zinc-400">
      {primaryExtractionSkippedReason(category)}{' '}
      {hash ? (
        <a
          href={`#${hash}`}
          className="text-indigo-600 hover:text-indigo-700 hover:underline dark:text-indigo-400 dark:hover:text-indigo-300"
        >
          {action}
        </a>
      ) : (
        action
      )}
    </p>
  );
}
